import React from 'react';
import BaseTile from '../../../components/Tile/BaseTile';
import ContentSection from '../../../components/layout/ContentSection';
import { formatGermanNumber, formatGermanPercentage } from '../../../utils/numberFormat';
import { useMissingTimestampsKpi } from './hooks/useMissingTimestampsKpi';

const Stat = ({ label, value, emphasize = false }) => (
  <div className="flex flex-col">
    <span className="text-xs text-gray-500">{label}</span>
    <span className={"text-lg " + (emphasize ? 'font-semibold text-gray-900' : 'text-gray-800')}>
      {typeof value === 'number' ? formatGermanNumber(value, { decimals: 0 }) : value}
    </span>
  </div>
);

const RatioBar = ({ ratio }) => {
  const pct = Math.max(0, Math.min(1, Number(ratio) || 0)) * 100;
  return (
    <div className="w-full h-2 bg-gray-200 rounded">
      <div className="h-2 bg-rose-500 rounded" style={{ width: `${pct}%` }} />
    </div>
  );
};



const MissingTimestamps = ({ activeFile, batchData }) => {
  const { data, loading, error } = useMissingTimestampsKpi(activeFile, { batchData });

  const total = data?.total_events ?? 0;
  const invalid = data?.invalid_timestamp_events ?? 0;
  const ratio = total > 0 ? (invalid / total) : 0;

  return (
    <ContentSection spacing="lg">
      <BaseTile
        title="Events with Missing/Invalid Timestamps"
        subtitle={total > 0 ? `${formatGermanNumber(invalid, { decimals: 0 })} of ${formatGermanNumber(total, { decimals: 0 })} events` : undefined}
        loading={loading}
        error={error}
        minHeight="sm"
      >
        <div className="p-4 flex flex-col gap-3">
          <RatioBar ratio={ratio} />
          <div className="flex items-center justify-between">
            <Stat label="Invalid events" value={invalid} emphasize />
            <Stat label="Total events" value={total} />
            <Stat label="Invalid ratio" value={formatGermanPercentage(ratio, 2)} />
          </div>
          {data?.criteria && (
            <div className="text-xs text-gray-500 mt-1">
              Criteria: {data.criteria}
            </div>
          )}
        </div>
      </BaseTile>
    </ContentSection>
  );
};

export default MissingTimestamps;
